module.exports = __webpack_public_path__ + "static/media/delete-rounded-wine.fe9f17f8.svg";